<template lang="html">
  <div 
    :class="{ active: showLoader }" 
    class="loader-container" >
    <span class="processing" />
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showLoader: false
    }
  },

  mounted() {
    var vm = this;
    this.showLoader = this.show;
    this.$root.$on('pageCreationFailed', function() {
      vm.showLoader = false;
    });

    this.$root.$on('creatingPage', function() {
      vm.showLoader = true;
    });

  }
}
</script>

<style lang="css">
  .loader-container {
      display: none;
      position: fixed;
      z-index: 999;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: 2em;
      width: 2em;
  }

  .loader-container.active {
      display: inline;
  }

  .processing {
    display: inline-block;
    height: 200px;
    width: 200px;
    background-repeat: no-repeat; 
    background-image: url('../../assets/img/loader-orange.gif');
  }
</style>
